module.exports = __webpack_public_path__ + "img/shield-shaded.96707ac6.svg";